import type { BoxProps } from '@mui/material/Box';

import { forwardRef } from 'react';

import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

export const HouseIcon = forwardRef<HTMLDivElement, BoxProps>((props, ref) => (
  <Box
    ref={ref}
    component="svg"
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.25 0C8.82107 0 9.37339 0.202688 9.80957 0.571289L9.81348 0.574219L15.6475 5.57324H15.6465C15.9133 5.7996 16.1281 6.08103 16.2754 6.39844C16.4233 6.71717 16.5 7.06465 16.5 7.41602V14.916C16.5 15.5569 16.2452 16.1718 15.792 16.625C15.3388 17.0782 14.7239 17.333 14.083 17.333H2.41699C1.77608 17.333 1.16122 17.0782 0.708008 16.625C0.254829 16.1718 0 15.5569 0 14.916V7.41602C-1.08059e-05 7.06464 0.076715 6.71717 0.224609 6.39844C0.371837 6.08126 0.585983 5.79951 0.852539 5.57324L6.68652 0.574219L6.69043 0.571289C7.12661 0.202688 7.67893 0 8.25 0ZM8.25 1.5C8.0334 1.5 7.82365 1.57699 7.6582 1.7168L7.65723 1.71582L1.8291 6.71191L1.8252 6.71582C1.72338 6.80187 1.64108 6.90935 1.58496 7.03027C1.52895 7.15111 1.49999 7.28283 1.5 7.41602V14.916C1.5 15.1591 1.59668 15.3925 1.76855 15.5645C1.94046 15.7363 2.1739 15.833 2.41699 15.833H5V9.91602C5.00009 9.49621 5.16701 9.09373 5.46387 8.79688C5.76072 8.50002 6.1632 8.33309 6.58301 8.33301H9.91699C10.3368 8.33309 10.7393 8.50002 11.0361 8.79688C11.333 9.09373 11.4999 9.49621 11.5 9.91602V15.833H14.083C14.3261 15.833 14.5595 15.7363 14.7314 15.5645C14.9033 15.3925 15 15.1591 15 14.916V7.41602C15 7.28283 14.9711 7.15111 14.915 7.03027C14.8589 6.90935 14.7766 6.80187 14.6748 6.71582L14.6709 6.71191L8.8418 1.71582V1.7168C8.67635 1.57699 8.4666 1.5 8.25 1.5ZM6.58301 9.83301C6.56102 9.83309 6.53997 9.84187 6.52441 9.85742C6.50886 9.87297 6.50009 9.89403 6.5 9.91602V15.833H10V9.91602C9.99991 9.89403 9.99114 9.87297 9.97559 9.85742C9.96003 9.84187 9.93898 9.83309 9.91699 9.83301H6.58301Z"
      fill="currentColor"
    />
  </Box>
));
